import { ON_VALIDATION_ERROR_METADATA_KEY } from './metadata-keys';
import { addToMetadata } from '@digitaix/helpers';

export function OnValidationError(order: number = -1) {
  return function(
    target: any,
    propertyKey: string
  ) {
    addToMetadata(
      ON_VALIDATION_ERROR_METADATA_KEY,
      {
        order,
        propertyKey
      },
      target
    );
  };
}
